export const HISTORY_POP = "POP";
export const MAX_MAP_SIZE = 5;
